module.exports = __webpack_public_path__ + "img/图标1.f1713481.png";